import React, { memo, useMemo } from 'react';
import { pick } from 'ramda';

import { View } from '../Base';
import {
  ADDRESS_SHORT,
  POSTCODE,
  TYPE_OF_COLLECTION,
  WINDOW,
} from '../../constants/strings';
import { getAddress } from '../../features/request/model';
import { getServiceWindow } from '../../models/stop';

const CollectionRequestContext = ({ stop, textStyle }) => {
  const request = stop.requests[0];
  const address = useMemo(() => getAddress(request.address), [request]);
  const window = useMemo(
    () =>
      getServiceWindow({
        ...pick(['serviceStartTime', 'serviceEndTime'], request),
        displayServiceWindow: true,
      }),
    [request]
  );

  return (
    <>
      <View className={textStyle.row}>
        <span className={textStyle.label}>{`${TYPE_OF_COLLECTION}:`}</span>
        <span className={textStyle.value}>{request.collectionType}</span>
      </View>
      <View className={textStyle.row}>
        <span className={textStyle.label}>{`${ADDRESS_SHORT}:`}</span>
        <span className={textStyle.value}>{address}</span>
        <span className={textStyle.spaceBetween} />
        <span className={textStyle.label}>{`${POSTCODE}:`}</span>
        <span className={textStyle.value}>{request.address?.postcode}</span>
      </View>
      <View className={textStyle.row}>
        <span className={textStyle.label}>{`${WINDOW}:`}</span>
        <span className={textStyle.value}>{window}</span>
      </View>
    </>
  );
};

export default memo(CollectionRequestContext);
